/** Retorna true se o JWT estiver expirado, sem `exp` ou malformado. */
export function tokenEstaExpirado(token: string | null | undefined): boolean {
  if (!token) {
    return true;
  }
  const partes = token.split('.');
  if (partes.length !== 3) {
    return true;
  }
  try {
    const base64 = partes[1].replace(/-/g, '+').replace(/_/g, '/');
    const preenchido = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
    const bytes = Uint8Array.from(atob(preenchido), (c) => c.charCodeAt(0));
    const payload = JSON.parse(new TextDecoder().decode(bytes)) as { exp?: unknown };
    if (typeof payload.exp !== 'number') {
      return true;
    }
    return payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
}
